// extracted by mini-css-extract-plugin
module.exports = {"template":"_1yMeYkuo","templateText":"YaOygFR6","imagePlaceholder":"_1L758CMr","templateTitle":"_2iA66TFk"};